<!--
 * @Description: 协外业务结算
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 15:09:56
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <!-- 导航 -->
        <div class="tabtop">
          <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
            <div v-if="currenindex !== index + 1 && currenindex !== index + 2 && index !== 2" class="hr"></div>
          </div>
        </div>
        <!-- 搜索条件 -->
        <div v-loading="pagesLoading">
          <!-- 折叠 -->
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <!-- 搜索内容 -->
          <el-collapse-transition>
            <div v-show="showCardNav" style="padding-top: 18px">
              <el-form :inline="true" label-width="110px">
                <!-- 搜索条件1 -->
                <el-form-item label-width="160px">
                  <span slot="label">协外单位</span>
                  <div style="width: 240px; height: 36px; display: flex">
                    <div :title="searchText" style="width: 180px; padding: 0 10px; border-bottom: 1px solid #bbb; margin-right: 5px" class="ellipsis">{{ searchText }}</div>
                    <el-button class="bottom_all_two" @click="((search = true), (supplierNameSearch = '')), getsearchData()">选择</el-button>
                  </div>
                </el-form-item>

                <el-form-item v-if="currenindex == 1">
                  <span slot="label">票面时间</span>
                  <el-date-picker
                    v-model="datePicker"
                    style="height: 36px"
                    type="datetimerange"
                    unlink-panels
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- 搜索条件2 -->
                <!-- <el-form-item v-if="currenindex == 2">
                  <span slot="label">协外单位</span>
                  <el-select v-model="tableParam.outsourcingUnitId" placeholder="请选择">
                    <el-option v-for="(item, index) in SupplierList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item v-if="currenindex == 2">
                  <span slot="label">结算单号</span>
                  <el-input v-model="tableParam.code" placeholder="请输入" clearable @keyup.enter.native="pagesgettableData()"></el-input>
                </el-form-item>
                <el-form-item v-if="currenindex == 2">
                  <span slot="label">生产日期</span>
                  <el-date-picker
                    v-model="datePicker"
                    style="height: 36px"
                    type="datetimerange"
                    unlink-panels
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="['00:00:00', '00:00:00']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- 搜索条件3 -->
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">结算单号</span>
                  <el-input v-model="tableParam.id" placeholder="请输入" clearable @keyup.enter.native="pagesgettableData()"></el-input>
                </el-form-item>
                <!-- <el-form-item v-if="currenindex == 3">
                  <span slot="label">协外单位</span>
                  <el-select v-model="tableParam.supplierId" placeholder="请选择">
                    <el-option v-for="(item, index) in SupplierList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">提交时间</span>
                  <el-date-picker
                    v-model="datePicker"
                    style="height: 36px"
                    type="datetimerange"
                    unlink-panels
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="['00:00:00', '00:00:00']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), pagesgettableData()">查 询</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <!-- 页面内容区 -->
          <div class="card" :style="currenindex !== 1 ? 'padding-top:10px' : ''">
            <!-- 页面功能按钮区 -->
            <div v-show="currenindex == 1" class="card_nav">
              <div>
                <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SHENGCJSD') !== -1" size="small" class="bottom_three" :disabled="generate.list.length == 0" @click="statements">生成结算单</el-button>
                <el-button size="small" class="bottom_three" @click="$router.push({ name: 'contactUnitRecord', query: { contractTypeId: '6' } })">协外结算价</el-button>
              </div>
              <div></div>
            </div>
            <!-- 表格数据 -->
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table ref="table" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="tableChange">
                <el-table-column v-if="currenindex == 1" align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <div v-if="item.label == '结算单号'" class="table_link" @click="show(scope.row)">
                        {{ scope.row[item.prop] }}
                      </div>
                      <!-- <div v-else-if="item.label == '浇筑方式'">
                        <div v-for="(item1, index1) in scope.row.list" :key="index1">
                          {{ item1[item.prop] }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '高度/臂长(米)'">
                        <div v-for="(item1, index1) in scope.row.list" :key="index1">
                          {{ item1[item.prop] }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '浇筑量（方）'">
                        <div v-for="(item1, index1) in scope.row.list" :key="index1">
                          {{ item1[item.prop] }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '泵送单价(元/方)'">
                        <div v-for="(item1, index1) in scope.row.list" :key="index1">
                          {{ item1[item.prop] }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '泵送时间'">
                        <div v-for="(item1, index1) in scope.row.list" :key="index1">
                          {{ item1[item.prop] }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '泵送费用（元）'">
                        <div v-for="(item1, index1) in scope.row.list" :key="index1">
                          {{ item1[item.prop] }}
                        </div>
                      </div> -->
                      <div v-else-if="item.label == '序号'">
                        {{ scope.$index + 1 }}
                      </div>
                      <span v-else-if="item.label == '结算时间段'">
                        {{ scope.row.settlementPeriod }}
                      </span>
                      <span v-else-if="item.label == '运输方'">
                        <span v-if="scope.row.isWxTransSettle == 1">{{ scope.row.outsourcingUnit }}</span>
                        <span v-else>{{ JSON.parse(searchradio).contractSigningSubject }}</span>
                      </span>
                      <span v-else-if="item.label == '内部审核状态'">
                        {{ scope.row.auditStatus == 1 ? "待提交" : scope.row.auditStatus == 2 ? "审核中" : scope.row.auditStatus == 3 ? "通过" : "未通过" }}
                      </span>
                      <span v-else-if="item.label == '结算单状态'">
                        {{ scope.row.settlementStatus == 2 ? "已结算" : "结算中" }}
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button v-if="scope.row.auditStatus == 3" class="bottom_one" size="mini" @click="userSubmit(scope.row)"> 发送 </el-button>
                        <el-button v-if="scope.row.auditStatus == 1" size="mini" class="bottom_one" @click="$router.push({ name: 'sign_Wise_contactsbusiness2', query: { id: scope.row.id, type: 1 } })">提交审核</el-button>
                        <el-button class="bottom_two" size="mini" @click="deleteBill(scope.row.id)"> 删除 </el-button>
                      </span>
                      <span v-else-if="item.label == '协外单位确认'">
                        {{ scope.row.outerStatus == 1 ? "待审核" : scope.row.outerStatus == 2 ? "通过" : "未发送" }}
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000, '全部']"
            layout="prev,pager,slot,next,jumper"
            :total="total"
            @current-change="pagesgettableData()"
          >
            <el-select v-model="curElPage" class="pageSelectContainer" placeholder="请选择" @change="changeSizes">
              <el-option v-for="item in optionsPage" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="pagesgettableData()">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 选择供应商合同 -->
    <el-dialog v-dialogDrag :visible.sync="search" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择往来协作单位</span>
      <div class="search">
        <span style="display: inline-block; margin-bottom: 10px">
          <span style="margin-right: 12px">单位名称</span>
          <el-input v-model="supplierNameSearch" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="getsearchData()" />
        </span>
        <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="getsearchData()">查 询</el-button>
      </div>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="searchData" tooltip-effect="dark" @row-click="setradio">
          <el-table-column align="center" label="选择">
            <template slot-scope="scope">
              <el-radio :value="searchradio" :label="JSON.stringify(scope.row)">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column align="center" label="往来协作合同编号" prop="contractNumber"></el-table-column>
          <el-table-column align="center" label="单位名称" prop="supplierName"></el-table-column>
          <el-table-column align="center" label="合同签订主体" prop="contractSigningSubject"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="search = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitsearch">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 协外业务结算 -->
    <el-dialog v-dialogDrag :visible.sync="billDeta" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">协外业务结算</span>
      <div ref="html" style="padding: 10px 20px">
        <div class="bill_top">
          <span><span class="text">协外单位：</span>{{ billDetails.outsourcingUnit }}</span>
          <span><span class="text">结算时间段：</span>{{ billDetails.createTime }}至{{ billDetails.updateTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billList.balanceNo }}</span>
        </div>
        <div class="bill_title1">{{ statementsType !== 4 ? "产品费用：" : "产品数据：" }}</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.hunPrice" tooltip-effect="dark" :span-method="hunPriceObjectSpanMethod">
          <el-table-column v-if="statementsType !== 4" label="时间段" align="center" prop="">
            <template slot-scope="scope">
              <span>{{ scope.row.informationPeriodStartTime + "-" + scope.row.informationPeriodEndTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="center" prop="productName"></el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column v-if="statementsType !== 4" label="产品组合" align="center" prop="splitProductStr">
            <template slot-scope="scope">
              <span>{{ (scope.row.splitProductStr = scope.row.splitProductList ? scope.row.splitProductList.join(",") : "") }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType !== 4" label="单价（元/m³）" align="center" prop="splitProductPriceStr">
            <template slot-scope="scope">
              <span>{{ (scope.row.splitProductPriceStr = scope.row.splitProductPrice ? scope.row.splitProductPrice.join("+") : "") }}</span>
            </template></el-table-column
          >
          <el-table-column v-if="statementsType !== 4" label="强度等级单价（元/m³）" align="center" prop="strengthPrice">
            <template slot-scope="scope"> <el-input v-model="scope.row.strengthPrice" :disabled="scope.row.adjustType == 4" type="Number" style="width: 100%" placeholder="请输入" clearable></el-input> </template
          ></el-table-column>
          <el-table-column v-if="statementsType !== 4" label="特添材料单价（元/m³）" align="center" prop="specialPrice">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specialPrice" type="Number" :disabled="scope.row.adjustType == 4" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType !== 4" label="结算单价（元）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column v-if="statementsType !== 4" label="结算金额（元）" align="center">
            <template slot-scope="scope">
              {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
            </template>
          </el-table-column>
        </el-table>
        <div v-if="billList.hunPrice.length !== 0 && statementsType !== 4" class="combined">小计：结算金额【{{ combined(billList.hunPrice) }}】</div>
        <el-table
          v-if="statementsType !== 3 && statementsType !== 4"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="billList.splitPrice"
          tooltip-effect="dark"
        >
          <el-table-column label="原材料" align="center" prop="rawName"></el-table-column>
          <el-table-column label="供应商" align="center" prop="supperName"></el-table-column>
          <el-table-column v-if="statementsType == 1" label="拆分金额（元）" align="center" prop="splitMoney">
            <template slot-scope="scope">
              <el-input v-model="scope.row.splitMoney" type="Number" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType == 1" label="数量" align="center" prop="splitNum"></el-table-column>
          <el-table-column v-if="statementsType == 1" label="配合比" align="center" prop="mixProportion"></el-table-column>
          <el-table-column label="单价" align="center" prop="price"></el-table-column>
          <el-table-column v-if="statementsType == 2" label="数量" align="center" prop="splitNum">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.splitNum"
                type="Number"
                style="width: 100%"
                placeholder="请输入"
                clearable
                @input="scope.row.splitNum = $regExp.checkNum4(scope.row.splitNum)"
                @blur="scope.row.splitNum = $regExp.blurCheckNum(scope.row.splitNum, true)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="settlementStatus">
            <template slot-scope="scope">
              {{ scope.row.settlementStatus == 2 ? "已结算" : "结算中" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="statements1(scope.row, scope.$index)">办理结算单</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="statementsType == 4" class="bill_title1">
          <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="addItem()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table v-if="statementsType == 4" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.splitPrice" tooltip-effect="dark">
          <el-table-column label="原材料" align="center" prop="rawName">
            <template slot-scope="scope">
              <span v-if="scope.row.rawName" class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index, scope.row.rawId)">{{ scope.row.rawName }}</span>
              <span v-else class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index)">选择</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center" prop="splitNum">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.splitNum"
                type="Number"
                style="width: 100%"
                placeholder="请输入"
                clearable
                @input="scope.row.splitNum = $regExp.checkNum4(scope.row.splitNum)"
                @blur="scope.row.splitNum = $regExp.blurCheckNum(scope.row.splitNum, true)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="deleteItem(scope.$index)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill_title1">泵送费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.pumpPrice" tooltip-effect="dark" :span-method="pumpPriceObjectSpanMethod">
          <el-table-column label="泵类型" align="center" prop="pumpCarName"></el-table-column>
          <el-table-column label="生效时间" align="center" prop="startSettleTime"></el-table-column>
          <el-table-column label="泵送方量(方)" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="补差方量(方)" align="center" prop="pumpSupplementNum"></el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="price"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.pumpPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.pumpPrice) }}】</div>
        <div class="bill_title1">泵送协助补差：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.assistPumpPrice]" tooltip-effect="dark">
          <el-table-column label="协助泵送方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="协助单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="泵送协助结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div class="bill_title1">特殊运载费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.specialTran" tooltip-effect="dark">
          <el-table-column label="浇筑方式" align="center" prop="pumpCarName"></el-table-column>
          <el-table-column label="方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="结算单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.specialTran.length !== 0" class="combined">小计：结算金额【{{ combined(billList.specialTran) }}】</div>
        <div class="bill_title1">超高层增加费：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.highOverPrice" tooltip-effect="dark">
          <el-table-column label="高度（米）" align="center" prop="highArea"></el-table-column>
          <el-table-column label="超高层方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.highOverPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.highOverPrice) }}】</div>
        <div class="bill_title1">运输费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.yunPrice" tooltip-effect="dark">
          <el-table-column label="运距（km）" align="center" prop="transportArea"></el-table-column>
          <el-table-column label="运输方量(方)" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="基本单价（元/方）" align="center" prop="price">
            <template slot-scope="scope">
              <span v-if="scope.row.addTransportRule">{{ scope.row.addTransportRule }}</span>
              <span v-else>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.yunPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.yunPrice) }}】</div>
        <div class="bill_title1">运输协助补差：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.assistTransportPrice]" tooltip-effect="dark">
          <el-table-column label="运输协助方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="协助单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="运输协助结算金额（元）" align="center" prop="">
            <template slot-scope="scope">
              {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
            </template>
          </el-table-column>
        </el-table>
        <div v-if="billList.supplyCarPrice">
          <div class="bill_title1">运输费用（车补）：</div>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.supplyCarPrice]" tooltip-effect="dark">
            <el-table-column label="单价（元/车）" align="center" prop="settlementPrice"></el-table-column>
            <el-table-column label="数量（车）" align="center" prop="signForNum"></el-table-column>
            <el-table-column label="结算金额（元）" align="center" prop="">
              <template slot-scope="scope">
                {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="!billList.supplyCarPrice">
          <div class="bill_title1">运输费用（方补）：</div>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.supplyNumPrice" tooltip-effect="dark">
            <el-table-column label="运距（km）" align="center" prop="transportArea"></el-table-column>
            <el-table-column label="运输方量(方)" align="center" prop="signForNum"></el-table-column>
            <el-table-column label="补差单价（元/方）" align="center" prop="price">
              <template slot-scope="scope">
                <span v-if="scope.row.addTransportRule">{{ scope.row.addTransportRule }}</span>
                <span v-else>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
          </el-table>
          <div v-if="billList.supplyNumPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.supplyNumPrice) }}】</div>
        </div>
        <div class="bill_title1">混凝土加工费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.jiaPrice" tooltip-effect="dark">
          <el-table-column label="站点" align="center" prop="productName"></el-table-column>
          <el-table-column label="加工方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="加工价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"></el-table-column>
        </el-table>
        <div v-if="billList.jiaPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.jiaPrice) }}】</div>
        <div class="bill_title1">特殊条款：</div>
        <div>{{ billList.specialItems }}</div>
        <!-- 结算补差 -->
        <div class="bill_title">
          结算补差
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="selectSenders()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            选择
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="compenList" tooltip-effect="dark" :span-method="sendersSpanMethod">
          <el-table-column label="时间段" align="center">
            <template slot-scope="scope">
              {{ scope.row.startSettleTime + "-" + scope.row.endSettleTime }}
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="center" prop="rawName"></el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="signForNum"> </el-table-column>
          <el-table-column label="原结算单价（元/m³）" align="center" prop="settlementPrice"> </el-table-column>
          <el-table-column label="补差单价（元/m³）" align="center" prop="price"> </el-table-column>
          <el-table-column label="结算补差金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div style="border-top: 0px" class="combined">小计：签收数量{{ combined4().signForNum }}，结算补差金额{{ combined4().settlementMoney }}</div>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="deductionList" tooltip-effect="dark">
          <el-table-column label="站点" align="center">
            <template slot-scope="scope">
              <el-select
                ref="station1"
                v-model="scope.row.stationId"
                style="width: 100%"
                placeholder="请选择站点"
                @change="
                  $nextTick(() => {
                    scope.row.station = $refs.station1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in billList.stationList" :key="item.stationId" :label="item.station" :value="item.stationId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center">
            <template slot-scope="scope">
              <el-select
                ref="deductionType1"
                v-model="scope.row.adjustModule"
                style="width: 100%"
                placeholder="请选择调整类型"
                @change="
                  $nextTick(() => {
                    scope.row.deductionType = $refs.deductionType1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in deductionTypes2" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增调减" align="center" prop="type">
            <template slot-scope="scope">
              <el-select ref="type" v-model="scope.row.type" style="width: 100%" placeholder="请选择">
                <el-option :key="1" label="调增" :value="1"></el-option>
                <el-option :key="2" label="调减" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.adjustMoney"
                placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.adjustMoney = $regExp.checkNum4(scope.row.adjustMoney)"
                @blur="scope.row.adjustMoney = $regExp.blurCheckNum(scope.row.adjustMoney)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.isInvoice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill_title">主合同单位结算合计：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="totalList" tooltip-effect="dark">
          <el-table-column label="协外单位" align="center" prop="supperName"> </el-table-column>
          <el-table-column label="合同签订主体" align="center" prop="contractSigningSubject"> </el-table-column>
          <el-table-column v-if="statementsType == 3" label="产品费用" align="center" prop="productMoney"> </el-table-column>
          <el-table-column label="运输费用" align="center" prop="transportMoney"> </el-table-column>
          <el-table-column label="泵送费用" align="center" prop="pumpMoney"> </el-table-column>
          <el-table-column label="特殊运载费用" align="center" prop="specialTransportMoney"> </el-table-column>
          <el-table-column label="超高层费用" align="center" prop="highOverMoney"> </el-table-column>
          <el-table-column label="混凝土加工费用" align="center" prop="machineMoney"> </el-table-column>
          <el-table-column label="调整费用" align="center" prop="adjustMoney"> </el-table-column>
          <el-table-column label="影响开票调整金额 (元)" align="center" prop="isAdjustMoney"> </el-table-column>
          <el-table-column label="不影响开票调整金额 (元)" align="center" prop="noAdjustMoney"> </el-table-column>
          <el-table-column label="结算金额 (元)" align="center" prop="settleMoney"> </el-table-column>
          <el-table-column label="开票金额(元)" align="center" prop="invoiceMoney">
            <!-- <template slot-scope="scope">
              <el-input
                v-model="scope.row.invoiceMoney"
                placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.invoiceMoney = $regExp.checkNum4(scope.row.invoiceMoney)"
                @blur="scope.row.invoiceMoney = $regExp.blurCheckNum(scope.row.invoiceMoney)"
              ></el-input>
            </template> -->
          </el-table-column>
        </el-table>
        <div v-if="statementsType !== 3 && statementsType !== 4" class="bill_title">结算合计：</div>
        <el-table
          v-if="statementsType !== 3 && statementsType !== 4"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="allTotalList"
          tooltip-effect="dark"
        >
          <el-table-column label="协外单位" align="center" prop="supperName"> </el-table-column>
          <el-table-column label="结算金额 (元)" align="center" prop="settlementMoney"> </el-table-column>
          <el-table-column label="开票金额(元)" align="center" prop="invoiceMoney"> </el-table-column>
          <el-table-column label="状态" align="center" prop="settlementStatus">
            <template slot-scope="scope">
              {{ scope.row.settlementStatus == 2 ? "已结算" : "结算中" }}
            </template>
          </el-table-column>
        </el-table>
        <div v-if="statementsType !== 3 && statementsType !== 4" class="combined">小计：结算金额【{{ combinedsettleMoney(allTotalList) }}】</div>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between">
        <div>
          <!-- <el-button class="bottom_all_two">打印结算单</el-button> -->
          <el-button class="bottom_all_two" @click="combinedSubmit(2)">提交审核</el-button>
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDeta = false">取 消</el-button>
          <el-button :disabled="saveStatus" class="bottom_all" style="margin-left: 24px" @click="combinedSubmit(1)">保 存</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 协外业务子订单结算 -->
    <el-dialog v-dialogDrag :visible.sync="billDetaChildren" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">协外业务-供应商结算单</span>
      <div ref="html" style="padding: 10px 20px">
        <div class="bill_top">
          <span><span class="text">供应商单位：</span>{{ billDetailsChildren.supperName }}</span>
          <span><span class="text">结算时间段：</span>{{ billDetailsChildren.createTime }}至{{ billDetailsChildren.updateTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billListChildren.balanceNo }}</span>
        </div>
        <div class="bill_title1">材料结算：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billListChildren.rawSettleData]" tooltip-effect="dark">
          <el-table-column label="原材料" align="center" prop="rawName"></el-table-column>
          <el-table-column label="供应商" align="center" prop="supperName"></el-table-column>
          <el-table-column v-if="statementsType == 1" label="拆分金额（元）" align="center" prop="splitMoney">
            <template slot-scope="scope">
              <el-input v-model="scope.row.splitMoney" type="Number" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType == 1" label="数量" align="center" prop="splitNum"></el-table-column>
          <el-table-column v-if="statementsType == 1" label="配合比" align="center" prop="mixProportion"></el-table-column>
          <el-table-column label="单价" align="center" prop="price"></el-table-column>
          <el-table-column v-if="statementsType == 2" label="数量" align="center" prop="splitNum">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.splitNum"
                type="Number"
                style="width: 100%"
                placeholder="请输入"
                clearable
                @input="scope.row.splitNum = $regExp.checkNum4(scope.row.splitNum)"
                @blur="scope.row.splitNum = $regExp.blurCheckNum(scope.row.splitNum, true)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType == 2" label="金额（元）" align="center" prop="signForNum">
            <template slot-scope="scope">
              {{ (scope.row.settlementMoney = Number(scope.row.price * scope.row.splitNum)).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem1Children()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="deductionListChildren" tooltip-effect="dark">
          <el-table-column label="站点" align="center">
            <template slot-scope="scope">
              <el-select
                ref="station1"
                v-model="scope.row.stationId"
                style="width: 100%"
                placeholder="请选择站点"
                @change="
                  $nextTick(() => {
                    scope.row.station = $refs.station1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in billList.stationList" :key="item.stationId" :label="item.station" :value="item.stationId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center">
            <template slot-scope="scope">
              <el-select
                ref="deductionType1"
                v-model="scope.row.adjustModule"
                style="width: 100%"
                placeholder="请选择调整类型"
                @change="
                  $nextTick(() => {
                    scope.row.deductionType = $refs.deductionType1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增调减" align="center" prop="type">
            <template slot-scope="scope">
              <el-select ref="type" v-model="scope.row.type" style="width: 100%" placeholder="请选择">
                <el-option :key="1" label="调增" :value="1"></el-option>
                <el-option :key="2" label="调减" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.adjustMoney"
                placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.adjustMoney = $regExp.checkNum4(scope.row.adjustMoney)"
                @blur="scope.row.adjustMoney = $regExp.blurCheckNum(scope.row.adjustMoney)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.isInvoice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1Children(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill_title">结算合计：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="totalListChildren" tooltip-effect="dark">
          <el-table-column label="结算单位" align="center" prop="supperName"> </el-table-column>
          <el-table-column label="材料结算" align="center" prop="rawMoney"> </el-table-column>
          <el-table-column label="调整费用" align="center" prop="adjustMoney"> </el-table-column>
          <el-table-column label="影响开票调整金额 (元)" align="center" prop="isAdjustMoney"> </el-table-column>
          <el-table-column label="不影响开票调整金额 (元)" align="center" prop="noAdjustMoney"> </el-table-column>
          <el-table-column label="结算金额 (元)" align="center" prop="settleMoney"> </el-table-column>
          <el-table-column label="开票金额(元)" align="center" prop="invoiceMoney">
            <!-- <template slot-scope="scope">
              <el-input
                v-model="scope.row.invoiceMoney"
                placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.invoiceMoney = $regExp.checkNum4(scope.row.invoiceMoney)"
                @blur="scope.row.invoiceMoney = $regExp.blurCheckNum(scope.row.invoiceMoney)"
              ></el-input>
            </template> -->
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between">
        <div>
          <!-- <el-button class="bottom_all_two">打印结算单</el-button> -->
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDetaChildren = false">取 消</el-button>
          <el-button :disabled="saveStatus" class="bottom_all" style="margin-left: 24px" @click="combinedSubmitChildren()">保 存</el-button>
        </div>
      </span>
    </el-dialog>
    <!--选择发送的人员-->
    <!-- <el-dialog v-dialogDrag :visible.sync="userDeta" width="620px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">请选择接收账号</span>
      <div style="padding:0 10px">
        <el-checkbox-group v-model="userarr">
          <template v-for="(item,index) in useroptons">
            <el-checkbox :key="index" style="line-height:26px" :label="item.id">{{item.name}}</el-checkbox>
          </template>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="userDeta=false">取 消</el-button>
        <el-button class="bottom_all" :disabled="userarr.length==0" style="margin-left: 24px" @click="userSubmit()">发 送</el-button>
      </span>
    </el-dialog> -->
    <!-- 查看结算明细 -->
    <el-dialog :visible.sync="billDeta1" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">协外业务结算</span>
      <div ref="html" style="padding: 10px 20px">
        <div class="bill_top">
          <span><span class="text">协外单位：</span>{{ billDetails1.supplierName }}</span>
          <span><span class="text">结算时间段：</span>{{ billDetails1.settlementPeriod }}</span>
          <span><span class="text">结算单编号：</span>{{ billDetails1.balanceNo }}</span>
        </div>
        <div class="bill_title1">{{ statementsType !== 4 ? "产品费用：" : "产品数据：" }}</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.hunPrice" tooltip-effect="dark" :span-method="hunPriceObjectSpanMethod">
          <el-table-column v-if="statementsType !== 4" label="时间段" align="center" prop="">
            <template slot-scope="scope">
              <span>{{ scope.row.informationPeriodStartTime + "-" + scope.row.informationPeriodEndTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="center" prop="productName"></el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column v-if="statementsType !== 4" label="产品组合" align="center" prop="splitProductStr"> </el-table-column>
          <el-table-column v-if="statementsType !== 4" label="单价（元/m³）" align="center" prop="splitProductPriceStr"> </el-table-column>
          <el-table-column v-if="statementsType !== 4" label="强度等级单价（元/m³）" align="center" prop="strengthPrice">
            <template slot-scope="scope">
              <el-input v-model="scope.row.strengthPrice" :disabled="scope.row.adjustType != 4" type="Number" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType !== 4" label="特添材料单价（元/m³）" align="center" prop="specialPrice">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specialPrice" :disabled="scope.row.adjustType != 4" type="Number" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType !== 4" label="结算单价 (元)" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column v-if="statementsType !== 4" label="结算金额（元）" align="center">
            <template slot-scope="scope">
              {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
            </template>
          </el-table-column>
        </el-table>
        <div v-if="billList.hunPrice.length !== 0 && statementsType !== 4" class="combined">小计：结算金额【{{ combined(billList.hunPrice) }}】</div>
        <el-table
          v-if="statementsType !== 3 && statementsType !== 4"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="billList.splitPrice"
          tooltip-effect="dark"
        >
          <el-table-column label="原材料" align="center" prop="rawName"></el-table-column>
          <el-table-column label="供应商" align="center" prop="supperName"></el-table-column>
          <el-table-column v-if="statementsType == 1" label="拆分金额（元）" align="center" prop="splitMoney">
            <template slot-scope="scope">
              <el-input v-model="scope.row.splitMoney" type="Number" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="statementsType == 1" label="数量" align="center" prop="splitNum"></el-table-column>
          <el-table-column v-if="statementsType == 1" label="配合比" align="center" prop="mixProportion"></el-table-column>
          <el-table-column label="单价" align="center" prop="price"></el-table-column>
          <el-table-column v-if="statementsType == 2" label="数量" align="center" prop="splitNum">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.splitNum"
                type="Number"
                style="width: 100%"
                placeholder="请输入"
                clearable
                @input="scope.row.splitNum = $regExp.checkNum4(scope.row.splitNum)"
                @blur="scope.row.splitNum = $regExp.blurCheckNum(scope.row.splitNum, true)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="settlementStatus">
            <template slot-scope="scope">
              {{ scope.row.settlementStatus == 2 ? "已结算" : "结算中" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="statements1(scope.row, scope.$index)">办理结算单</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="statementsType == 4" class="bill_title1">
          <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="addItem()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table v-if="statementsType == 4" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.splitPrice" tooltip-effect="dark">
          <el-table-column label="原材料" align="center" prop="rawName">
            <template slot-scope="scope">
              <span v-if="scope.row.rawName" class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index, scope.row.rawId)">{{ scope.row.rawName }}</span>
              <span v-else class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index)">选择</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center" prop="splitNum">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.splitNum"
                type="Number"
                style="width: 100%"
                placeholder="请输入"
                clearable
                @input="scope.row.splitNum = $regExp.checkNum4(scope.row.splitNum)"
                @blur="scope.row.splitNum = $regExp.blurCheckNum(scope.row.splitNum, true)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="deleteItem(scope.$index)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill_title1">泵送费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.pumpPrice" tooltip-effect="dark" :span-method="pumpPriceObjectSpanMethod">
          <el-table-column label="泵类型" align="center" prop="pumpCarName"></el-table-column>
          <el-table-column label="生效时间" align="center" prop="startSettleTime"></el-table-column>
          <el-table-column label="泵送方量(方)" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="补差方量(方)" align="center" prop="pumpSupplementNum"></el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="price"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.pumpPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.pumpPrice) }}】</div>
        <div class="bill_title1">泵送协助补差：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.assistPumpPrice]" tooltip-effect="dark">
          <el-table-column label="协助泵送方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="协助单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="泵送协助结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div class="bill_title1">特殊运载费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.specialTran" tooltip-effect="dark">
          <el-table-column label="浇筑方式" align="center" prop="pumpCarName"></el-table-column>
          <el-table-column label="方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="结算单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.specialTran.length !== 0" class="combined">小计：结算金额【{{ combined(billList.specialTran) }}】</div>
        <div class="bill_title1">超高层增加费：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.highOverPrice" tooltip-effect="dark">
          <el-table-column label="高度（米）" align="center" prop="highArea"></el-table-column>
          <el-table-column label="超高层方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.highOverPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.highOverPrice) }}】</div>
        <div class="bill_title1">运输费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.yunPrice" tooltip-effect="dark">
          <el-table-column label="运距（km）" align="center" prop="transportArea"></el-table-column>
          <el-table-column label="运输方量(方)" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="基本单价（元/方）" align="center" prop="price">
            <template slot-scope="scope">
              <span v-if="scope.row.addTransportRule">{{ scope.row.addTransportRule }}</span>
              <span v-else>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div v-if="billList.yunPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.yunPrice) }}】</div>
        <div class="bill_title1">运输协助补差：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.assistTransportPrice]" tooltip-effect="dark">
          <el-table-column label="运输协助方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="协助单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="运输协助结算金额（元）" align="center" prop="">
            <template slot-scope="scope">
              {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
            </template>
          </el-table-column>
        </el-table>
        <div v-if="billList.supplyCarPrice">
          <div class="bill_title1">运输费用（车补）：</div>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.supplyCarPrice]" tooltip-effect="dark">
            <el-table-column label="单价（元/车）" align="center" prop="settlementPrice"></el-table-column>
            <el-table-column label="数量（车）" align="center" prop="signForNum"></el-table-column>
            <el-table-column label="结算金额（元）" align="center" prop="">
              <template slot-scope="scope">
                {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="!billList.supplyCarPrice">
          <div class="bill_title1">运输费用（方补）：</div>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.supplyNumPrice" tooltip-effect="dark">
            <el-table-column label="运距（km）" align="center" prop="transportArea"></el-table-column>
            <el-table-column label="运输方量(方)" align="center" prop="signForNum"></el-table-column>
            <el-table-column label="补差单价（元/方）" align="center" prop="price">
              <template slot-scope="scope">
                <span v-if="scope.row.addTransportRule">{{ scope.row.addTransportRule }}</span>
                <span v-else>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
          </el-table>
          <div v-if="billList.supplyNumPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.supplyNumPrice) }}】</div>
        </div>
        <div class="bill_title1">混凝土加工费用：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.jiaPrice" tooltip-effect="dark">
          <el-table-column label="站点" align="center" prop="productName"></el-table-column>
          <el-table-column label="加工方量（方）" align="center" prop="signForNum"></el-table-column>
          <el-table-column label="加工价（元/方）" align="center" prop="settlementPrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"></el-table-column>
        </el-table>
        <div v-if="billList.jiaPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.jiaPrice) }}】</div>
        <div class="bill_title1">特殊条款：</div>
        <div>{{ billList.specialItems }}</div>
        <!-- 结算补差 -->
        <div class="bill_title">
          结算补差
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="lookSenders()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            查看明细
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="compenList" tooltip-effect="dark" :span-method="sendersSpanMethod">
          <el-table-column label="时间段" align="center">
            <template slot-scope="scope">
              {{ scope.row.startSettleTime + "-" + scope.row.endSettleTime }}
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="center" prop="rawName"></el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="signForNum"> </el-table-column>
          <el-table-column label="原结算单价（元/m³）" align="center" prop="settlementPrice"> </el-table-column>
          <el-table-column label="补差单价（元/m³）" align="center" prop="price"> </el-table-column>
          <el-table-column label="结算补差金额（元）" align="center" prop="settlementMoney"> </el-table-column>
        </el-table>
        <div style="border-top: 0px" class="combined">小计：签收数量{{ combined4().signForNum }}，结算补差金额{{ combined4().settlementMoney }}</div>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="deductionList" tooltip-effect="dark">
          <el-table-column label="站点" align="center">
            <template slot-scope="scope">
              <el-select
                ref="station1"
                v-model="scope.row.stationId"
                style="width: 100%"
                placeholder="请选择站点"
                @change="
                  $nextTick(() => {
                    scope.row.station = $refs.station1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in billList.stationList" :key="item.stationId" :label="item.station" :value="item.stationId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center">
            <template slot-scope="scope">
              <el-select
                ref="deductionType1"
                v-model="scope.row.adjustModule"
                style="width: 100%"
                placeholder="请选择调整类型"
                @change="
                  $nextTick(() => {
                    scope.row.deductionType = $refs.deductionType1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in deductionTypes2" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增调减" align="center" prop="type">
            <template slot-scope="scope">
              <el-select ref="type" v-model="scope.row.type" style="width: 100%" placeholder="请选择">
                <el-option :key="1" label="调增" :value="1"></el-option>
                <el-option :key="2" label="调减" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.adjustMoney"
                placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.adjustMoney = $regExp.checkNum4(scope.row.adjustMoney)"
                @blur="scope.row.adjustMoney = $regExp.blurCheckNum(scope.row.adjustMoney)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.isInvoice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill_title">主合同单位结算合计：</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="totalList" tooltip-effect="dark">
          <el-table-column label="协外单位" align="center" prop="supperName"> </el-table-column>
          <el-table-column label="合同签订主体" align="center" prop="contractSigningSubject"> </el-table-column>
          <el-table-column v-if="statementsType == 3" label="产品费用" align="center" prop="productMoney"> </el-table-column>
          <el-table-column label="运输费用" align="center" prop="transportMoney"> </el-table-column>
          <el-table-column label="泵送费用" align="center" prop="pumpMoney"> </el-table-column>
          <el-table-column label="特殊运载费用" align="center" prop="specialTransportMoney"> </el-table-column>
          <el-table-column label="超高层费用" align="center" prop="highOverMoney"> </el-table-column>
          <el-table-column label="混凝土加工费用" align="center" prop="machineMoney"> </el-table-column>
          <el-table-column label="调整费用" align="center" prop="adjustMoney"> </el-table-column>
          <el-table-column label="影响开票调整金额 (元)" align="center" prop="isAdjustMoney"> </el-table-column>
          <el-table-column label="不影响开票调整金额 (元)" align="center" prop="noAdjustMoney"> </el-table-column>
          <el-table-column label="结算金额 (元)" align="center" prop="settleMoney"> </el-table-column>
          <el-table-column label="开票金额(元)" align="center" prop="invoiceMoney">
            <!-- <template slot-scope="scope">
              <el-input
                v-model="scope.row.invoiceMoney"
                placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.invoiceMoney = $regExp.checkNum4(scope.row.invoiceMoney)"
                @blur="scope.row.invoiceMoney = $regExp.blurCheckNum(scope.row.invoiceMoney)"
              ></el-input>
            </template> -->
          </el-table-column>
        </el-table>
        <div v-if="statementsType !== 3 && statementsType !== 4" class="bill_title">结算合计：</div>
        <el-table
          v-if="statementsType !== 3 && statementsType !== 4"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="allTotalList"
          tooltip-effect="dark"
        >
          <el-table-column label="协外单位" align="center" prop="supperName"> </el-table-column>
          <el-table-column label="结算金额 (元)" align="center" prop="settleMoney"> </el-table-column>
          <el-table-column label="开票金额(元)" align="center" prop="invoiceMoney"> </el-table-column>
          <el-table-column label="状态" align="center" prop="settlementStatus">
            <template slot-scope="scope">
              {{ scope.row.settlementStatus == 2 ? "已结算" : "结算中" }}
            </template>
          </el-table-column>
        </el-table>
        <div v-if="statementsType !== 3 && statementsType !== 4" class="combined">小计：结算金额【{{ combinedsettleMoney(allTotalList) }}】</div>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between">
        <div>
          <el-button class="bottom_all_two" @click="download()">导出</el-button>
          <el-button class="bottom_all_two" @click="combinedSubmit(2)">提交审核</el-button>
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDeta1 = false">取 消</el-button>
          <el-button :disabled="saveStatus" class="bottom_all" style="margin-left: 24px" @click="combinedSubmit(1)">保 存</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 列表单选 -->
    <el-dialog v-dialogDrag :visible.sync="ListChoiceType" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择</span>
      <div class="dialogOtherinfo">
        <div style="position: relative; margin-bottom: 10px; height: 30px">
          <div class="form-title">原物料查询</div>
          <div style="position: absolute; right: 0; top: 0">
            名称：
            <el-input v-model="checkName" size="mini" style="width: 120px"></el-input>
            <!-- 规格：
            <el-input v-model="checkSpec" size="mini" style="width: 120px"></el-input> -->
            类型：
            <el-select v-model="checkTypeId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(v, k) in checkTypeIdList" :key="k" :label="v.itemName" :value="v.id"></el-option>
            </el-select>
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="ListChoicePagingFun()">搜索</el-button>
          </div>
        </div>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="ListChoiceData"
          tooltip-effect="dark"
          highlight-current-row
          @row-click="ListChoiceFun"
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="ListChoiceRadio" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="barCode" label="原物料编号" width="auto" align="center"></el-table-column>
          <el-table-column prop="name" label="原物料名称" width="auto" align="center"></el-table-column>
          <el-table-column prop="brand" label="品牌" width="auto" align="center"></el-table-column>
          <el-table-column prop="specification" label="规格" width="auto" align="center"></el-table-column>
          <el-table-column prop="originPlace" label="产地" width="auto" align="center"></el-table-column>
          <el-table-column prop="typeName" label="类型" width="auto" align="center"></el-table-column>
          <el-table-column prop="enable" label="状态" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
              <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="ListChoicePaging.page"
          :page-size="ListChoicePaging.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="ListChoicePaging.total"
          @current-change="ListChoicePagingFun(true)"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="ListChoiceType = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="ListChoiceAddFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择补差 -->
    <el-dialog :visible.sync="sendersDig" width="960px" :close-on-click-modal="false" :append-to-body="true">
      <span slot="title" class="dialog-title">结算补差选择</span>
      <div class="dialoginfo">
        <div v-if="!lookSendersStatus">
          <span>签收时间段：</span>
          <el-date-picker
            v-model="sendersDate"
            style="height: 36px"
            type="datetimerange"
            unlink-panels
            align="right"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '00:00:00']"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <el-button icon="el-icon-search" style="margin-left: 10px" size="medium" class="bottom_all" @click="getCompensationList()">查 询</el-button>
        </div>
        <el-table
          ref="senderDigTable"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          :data="senderDigList"
          tooltip-effect="dark"
          :row-key="getRowKeys"
          @selection-change="changeSenders"
        >
          <el-table-column v-if="!lookSendersStatus" type="selection" :reserve-selection="true" width="55"> </el-table-column>
          <el-table-column label="车牌号" align="center" prop="carNo"></el-table-column>
          <el-table-column label="产品名称" align="center" prop="productName"></el-table-column>
          <el-table-column label="签收时间" align="center" prop="proTime"></el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="faceValue"></el-table-column>
          <el-table-column label="原结算单价（元/m³）" align="center" prop="oldSettlementPrice"></el-table-column>
          <el-table-column label="补差单价（元/m³）" align="center" prop="price">
            <template slot-scope="scope">
              <span>{{ (scope.row.price = Number(scope.row.newSettlementPrice - scope.row.oldSettlementPrice)).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="补差金额（元）" align="center" prop="newSettlementPrice"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="sendersDig = false">取 消</el-button>
        <el-button v-if="!lookSendersStatus" class="bottom_all" style="margin-left: 24px" @click="confirmSenders">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  contract_list,
  queryPage1,
  createFinalStatement,
  saveFinalStatement,
  saveRawStatement,
  queryPage3,
  //getSupplierListForsettlement,
  queryPage2,
  // queryUserByID,
  informClient,
  selectSettleDetail,
  selectRawSettleDetail,
  outsourceexportList,
  updateSettledPage,
  createRawSettle,
  exportSettlement,
  exportRawSettlement,
  deleteFinalStatement,
  getCompensationList,
  getCompensationListHistory,
} from "@/api/wise/Wise_contactsbusiness/Wise_contactsbusiness.js";
import { rawMaterialsQueryPage } from "@/api/GHnumber/outsourcing.js";
import { uploadFile } from "@/api/common.js";
import { getDicType } from "@/api/common.js";
import { _debounce } from "@/utils/utils.js";
import html2canvas from "html2canvas";
export default {
  mixins: [mixin],
  data() {
    return {
      //分页
      optionsPage: [
        {
          label: "10条/页",
          value: 10,
        },
        {
          label: "20条/页",
          value: 20,
        },
        {
          label: "30条/页",
          value: 30,
        },
        {
          label: "40条/页",
          value: 40,
        },
        {
          label: "50条/页",
          value: 50,
        },
        {
          label: "100条/页",
          value: 100,
        },
        {
          label: "200条/页",
          value: 200,
        },
        {
          label: "500条/页",
          value: 500,
        },
        {
          label: "1000条/页",
          value: 1000,
        },
        {
          label: "全部",
          value: 100000,
        },
      ],
      curElPage: 100000, //默认每页显示20条
      pagesLoading: false,
      /*表格增删改查及下载接口*/
      queryPage: "",
      /*表格数据*/
      table: [],
      table1: [
        { label: "协外单位", width: "auto", prop: "outsourcingUnit", status: true },
        { label: "订单号", width: "auto", prop: "orderNo", status: true },
        { label: "运输号", width: "auto", prop: "code", status: true },
        { label: "车牌号", width: "auto", prop: "carNo", status: true },
        { label: "协作站点", width: "auto", prop: "station", status: true },
        { label: "产品名称", width: "auto", prop: "productName", status: true },
        { label: "生产票面量(方)", width: "auto", prop: "faceValue", status: true },
        { label: "产品单价（元/方）", width: "auto", prop: "unitPrice", status: true },
        { label: "混凝土生产费用(元)", width: "auto", prop: "productCost", status: true },
        { label: "加工单价(元/方)", width: "auto", prop: "processingUnitPrice", status: true },
        { label: "混凝土加工费用(元)", width: "auto", prop: "processingCost", status: true },
        { label: "运输距离(千米)", width: "auto", prop: "transportDistance", status: true },
        { label: "运输单价(元/方)", width: "auto", prop: "transportPrice", status: true },
        { label: "运输方", width: "auto", prop: "outsourcingUnit", status: true },
        { label: "混凝土运输费用(元)", width: "auto", prop: "transportCost", status: true },
        { label: "浇筑方式", width: "auto", prop: "pouringMethod", status: true },
        { label: "高度/臂长(米)", width: "auto", prop: "pouringHigh", status: true },
        { label: "浇筑量（方）", width: "auto", prop: "quantity", status: true },
        { label: "泵送单价(元/方)", width: "auto", prop: "pumpPrice", status: true },
        { label: "泵送费用（元）", width: "auto", prop: "pumpCost", status: true },
        { label: "票面时间", width: "auto", prop: "affirmTime", status: true },
        { label: "结算金额 (元)", width: "auto", prop: "settlementAmount", status: true },
      ],
      table2: [
        { label: "协外单位", width: "auto", prop: "outsourcingUnit", status: true },
        { label: "订单号", width: "auto", prop: "orderNo", status: true },
        { label: "运输号", width: "auto", prop: "code", status: true },
        { label: "车牌号", width: "auto", prop: "carNo", status: true },
        { label: "协作站点", width: "auto", prop: "station", status: true },
        { label: "产品名称", width: "auto", prop: "productName", status: true },
        { label: "生产票面量(方)", width: "auto", prop: "faceValue", status: true },
        { label: "生产日期", width: "auto", prop: "proTime", status: true },
        { label: "产品单价（元/方）", width: "auto", prop: "unitPrice", status: true },
        { label: "混凝土生产费用(元)", width: "auto", prop: "productCost", status: true },
        { label: "加工单价(元/方)", width: "auto", prop: "processingUnitPrice", status: true },
        { label: "混凝土加工费用(元)", width: "auto", prop: "processingCost", status: true },
        { label: "运输距离(千米)", width: "auto", prop: "transportDistance", status: true },
        { label: "运输单价(元/方)", width: "auto", prop: "transportPrice", status: true },
        { label: "混凝土运输费用(元)", width: "auto", prop: "transportCost", status: true },
        { label: "浇筑方式", width: "auto", prop: "pouringWay", status: true },
        { label: "高度/臂长(米)", width: "auto", prop: "height", status: true },
        { label: "浇筑量（方）", width: "auto", prop: "num", status: true },
        { label: "泵送单价(元/方)", width: "auto", prop: "price", status: true },
        { label: "泵送费用（元）", width: "auto", prop: "zongCost", status: true },
        { label: "票面时间", width: "auto", prop: "affirmTime", status: true },
        { label: "结算金额 (元)", width: "auto", prop: "settlementAmount", status: true },
        { label: "结算单号", width: "auto", prop: "balanceNo", status: true },
      ],
      table3: [
        { label: "序号", width: "50", prop: "", status: true },
        { label: "结算单号", width: "120", prop: "id", status: true },
        { label: "协外单位", width: "auto", prop: "supplierName", status: true },
        { label: "结算时间段", width: "120", prop: "settlementPeriod", status: true },
        { label: "结算总金额（元）", width: "auto", prop: "money", status: true },
        { label: "提交时间", width: "120", prop: "createTime", status: true },
        { label: "结算单状态", width: "120", prop: "settlementStatus", status: true },
        { label: "内部审核状态", width: "120", prop: "", status: true },
        { label: "操作", width: "auto", prop: "", status: true },
        { label: "协外单位确认", width: "120", prop: "", status: true },
      ],
      pagesType: 0,
      /**导航栏*/
      navlist: [
        {
          value: "待结算",
          id: 1,
        },
        {
          value: "已结算",
          id: 2,
        },
        {
          value: "结算单",
          id: 3,
        },
      ],
      currenindex: 1,
      /**时间*/
      datePicker: [],
      /**搜索条件1*/
      searchText: "",
      search: false,
      searchData: [],
      searchradio: "",
      /**生成结算的数据*/
      generate: {
        list: [],
        startTime: "",
        endTime: "",
        contractId: "",
      },
      /*结算单详情*/
      billDeta: false,
      billDetaChildren: false,
      billDetails: {},
      billDetailsChildren: {},
      totalListChildren: [
        {
          id: "",
          supperName: "",
          betonMoney: 0,
          transportMoney: 0,
          pumpMoney: 0,
          machineMoney: 0,
          adjustMoney: 0,
          isAdjustMoney: 0,
          noAdjustMoney: 0,
          settlementMoney: 0,
          invoiceMoney: 0,
          settleType: 1,
        },
      ],
      billList: {
        jiaPrice: [],
        pumpPrice: [],
        specialTran: [],
        assistPumpPrice: [],
        highOverPrice: [],
        yunPrice: [],
        assistTransportPrice: [],
        supplyCarPrice: [],
        supplyNumPrice: [],
        hunPrice: [],
        splitPrice: [],
        settlementInfo: {},
        stationList:[],
      },
      billListChildren: {
        jiaPrice: [],
        pumpPrice: [],
        yunPrice: [],
        hunPrice: [],
        statements: [],
        splitPrice: [],
        mainSupperPrice: [],
        adjustPrice: [],
      },
      totalList: [
        {
          id: "",
          supperName: "",
          betonMoney: 0,
          transportMoney: 0,
          pumpMoney: 0,
          specialTransportMoney: 0,
          machineMoney: 0,
          adjustMoney: 0,
          isAdjustMoney: 0,
          noAdjustMoney: 0,
          settlementMoney: 0,
          invoiceMoney: 0,
          settleType: 1,
          settlementStatus: "",
        },
      ],
      allTotalList: [],
      SupplierList: [],
      deductionList: [],
      deductionListChildren: [],
      /**发送*/
      userDeta: false,
      useroptons: [],
      userarr: [],
      low: {},
      /**结算明旭*/
      billDeta1: false,
      billDetails1: {},
      deductionTypes: [],
      deductionTypes2: [
        { id: "1", itemName: "产品费用" },
        { id: "2", itemName: "泵送费用" },
        { id: "3", itemName: "运输费用" },
        { id: "4", itemName: "混凝土加工费用" },
      ],
      statementsType: 1,
      supplierNameSearch: "",
      checkName: "",
      checkTypeId: "",
      checkTypeIdList: [],
      ListChoiceType: false, //单选表格是否打开
      ListChoiceData: [], //单选表格数据
      ListChoiceRadio: "", //单选表格选中项
      ListChoiceRadioCopy: "", //当前打开的单选表格选中项
      ListChoiceRadioRow: {}, //单选表格选中的对象
      ListChoiceDataIndex: "", //点击的表格数据下标
      ListChoicePaging: {
        //单选表格分页
        pageSize: 5,
        page: 1,
        total: 0,
        name: "",
        enable: 1,
      },
      statementsNoIndex: "",
      statementsNoRow: {},
      //结算补差-调整开始
      compenList: [],
      senderDigList: [],
      selectCompenList: [],
      sendersDig: false,
      sendersDate: [],
      spanArr: {},
      pos: "",
      deductionListCopy: [],
      lookSendersStatus:false,
      //结算补差-调整结束
      saveStatus: false,
    };
  },
  async created() {
    const { data } = await getDicType({ code: "deductionType" });
    this.deductionTypes = data.items;
    this.tableParam.pageSize = this.curElPage;
    getDicType({ code: "MATtype" }).then(res => {
      this.checkTypeIdList = res.data.items; //
    });
  },
  watch: {
    /**导航切换*/
    currenindex: {
      handler() {
        this.tableData = [];
        this.datePicker = [];
        this.tableParam = this.$options.data().tableParam;
        this.tableParam.pageSize = this.curElPage;
        this.tableParam.contractType = 6;
        this.searchText = "";
        this.searchradio = "";
        this.low = {};
        this.totalList = [
          {
            id: "",
            supperName: "",
            betonMoney: 0,
            transportMoney: 0,
            pumpMoney: 0,
            machineMoney: 0,
            adjustMoney: 0,
            isAdjustMoney: 0,
            noAdjustMoney: 0,
            settlementMoney: 0,
            invoiceMoney: 0,
            settleType: 1,
            settlementStatus: "",
          },
        ];
        if (this.currenindex == 1) {
          this.table = this.table1;
          this.queryPage = queryPage1;
          this.tableParam.isSettle = 0;
          this.tableParam.pageSize = 10;
          this.curElPage = 10
        }
        if (this.currenindex == 2) {
          this.tableParam.type = 2;
          this.tableParam.pageSize = 10;
          this.curElPage = 10
          this.table = this.table2;
          this.getsearchData();
          this.queryPage = queryPage2;
          this.gettableData();
        }
        if (this.currenindex == 3) {
          this.table = this.table3;
          this.tableParam.type = 2;
          this.tableParam.pageSize = 10;
          this.curElPage = 10
          this.queryPage = queryPage3;
          this.getsearchData();
          this.gettableData();
        }
        this.pagesLoading = false;
        //此处为执行的函数或者方法
      },
      deep: false,
      immediate: true,
    },
    /**时间选择*/
    datePicker() {
      if (this.datePicker) {
        this.tableParam.startTime = this.datePicker[0];
        this.tableParam.endTime = this.datePicker[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
    /**table1默认全选*/
    tableData() {
      if (this.tableData.length !== 0 && this.currenindex == 1) {
        this.$refs.table.toggleAllSelection();
        this.generate.createTime = this.tableParam.startTime;
        this.generate.updateTime = this.tableParam.endTime;
      }
    },
    /**结算合计*/
    tatol: {
      handler() {
        this.settotalList();
      },
      deep: true,
      immediate: false,
    },
    /**子结算合计*/
    tatolChildren: {
      handler() {
        this.settotalListChildren();
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    tatol() {
      return {
        billList: this.billList,
        deductionList: this.deductionList,
      };
    },
    tatolChildren() {
      return {
        billListChildren: this.billListChildren,
        deductionListChildren: this.deductionListChildren,
      };
    },
  },
  methods: {
    /*补差 */
    /**结算补差合计*/
    combined4() {
      let num = 0;
      let num2 = 0;
      this.compenList.forEach(res => {
        num = Number(res.settlementMoney) + num;
        num2 = Number(res.signForNum) + num2;
      });
      return { settlementMoney: num, signForNum: num2 };
    },
    getRowKeys(row) {
      return row.id; //一般是你选择项的id
    },
    async getCompensationList() {
      let startTime = "";
      let endTime = "";
      if (this.sendersDate.length > 0) {
        startTime = this.sendersDate[0];
        endTime = this.sendersDate[1];
      }
      await getCompensationList({ startTime: startTime, endTime: endTime }).then(res => {
        if (res.code == 1001) {
          this.senderDigList = res.data;
        }
      });
    },
    lookSenders(){
      this.sendersDig = true;
      this.senderDigList =this.selectCompenList;
    },
    async selectSenders() {
      this.getCompensationList();
      this.selectCompenList = [];
      this.sendersDate = [];
      //let arr = [];
      this.sendersDig = true;
      setTimeout(() => {
        this.$refs.senderDigTable.clearSelection();
        if (this.selectCompenList.length > 0) {
          this.$refs.senderDigTable.toggleRowSelection(this.selectCompenList, true);
        }
      }, 500);
    },
    changeSenders(val) {
      this.selectCompenList = [];
      this.selectCompenList = val;
    },
    confirmSenders() {
      this.compenList = [];
      this.selectCompenList.sort((a, b) => {
        return b.productName - a.productName;
      });
      let copySelectSendersList = JSON.parse(JSON.stringify(this.selectCompenList));
      this.compenList = copySelectSendersList.reduce((pre, cur) => {
        let sameType = false;
        let obj = {
          startSettleTime: cur.startSettleTime,
          endSettleTime: cur.endSettleTime,
          rawName: cur.productName,
          signForNum: cur.faceValue, //签收数量（方）
          settlementPrice: cur.oldSettlementPrice, //原结算单价（元
          price: Number(cur.newSettlementPrice - cur.oldSettlementPrice).toFixed(2), //补差单价（元
          settlementMoney: cur.newSettlementPrice, //结算补差金额（元）
          type: 11,
        };
        if (pre.length == 0) {
          pre.push(obj);
        } else {
          pre.forEach(item => {
            if (item.rawName == cur.productName && item.startSettleTime == cur.startSettleTime && item.endSettleTime == cur.endSettleTime) {
              sameType = true;
              item.settlementMoney = Number(item.settlementMoney * 1 + cur.newSettlementPrice * 1).toFixed(2);
            }
          });
          if (!sameType) {
            pre.push(obj);
          }
        }
        return pre;
      }, []);
      this.getSpanArr(this.compenList);
      this.sendersDig = false;
    },
    /* */
    sendersSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        const _row = this.spanArr[row.startSettleTime + "time" + row.endSettleTime][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex == 1) {
        const _row = this.spanArr[row.rawName][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    getSpanArr(data) {
      if (data.length == 0) {
        return;
      }
      console.log("zmmm--", data); //从后台获取的数据
      this.spanArr = {};
      this.pos = 0;
      data.forEach((items, indexs) => {
        if (indexs === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr[items.rawName] = [];
          this.spanArr[items.rawName].push(1);
          this.pos = 0;
        } else {
          if (items.rawName === data[indexs - 1].rawName) {
            // 如果itemCode相等就累加，并且push 0
            this.spanArr[items.rawName][this.pos] += 1;
            this.spanArr[items.rawName].push(0);
          } else {
            // 不相等push 1
            let same = false;
            Object.keys(this.spanArr).forEach(spanItem => {
              if (spanItem == items.rawName) {
                same = true;
              }
            });
            if (!same) {
              this.spanArr[items.rawName] = [];
            }
            this.spanArr[items.rawName][indexs] = 1;
            this.pos = indexs;
          }
        }
      });
      data.forEach((items, indexs) => {
        let key = items.startSettleTime + "time" + items.endSettleTime;
        if (indexs === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr[key] = [];
          this.spanArr[key].push(1);
          this.pos = 0;
        } else {
          if (items.startSettleTime === data[indexs - 1].startSettleTime && items.endSettleTime === data[indexs - 1].endSettleTime) {
            // 如果itemCode相等就累加，并且push 0
            this.spanArr[key][this.pos] += 1;
            this.spanArr[key].push(0);
          } else {
            // 不相等push 1
            let same = false;
            Object.keys(this.spanArr).forEach(spanItem => {
              if (spanItem == key) {
                same = true;
              }
            });
            if (!same) {
              this.spanArr[key] = [];
            }
            // this.spanArr[items.receiveStationId].push(1);
            this.spanArr[key][indexs] = 1;
            this.pos = indexs;
          }
        }
      });
      console.log(this.spanArr);
    },
    /*补差 */
    hunPriceObjectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0 && this.statementsType !== 4) {
        // 获取当前单元格的值
        const currentValue = row["informationPeriodStartTime"] + "-" + row["informationPeriodEndTime"];
        // 获取上一行相同列的值
        const preRow = this.billList.hunPrice[rowIndex - 1];
        const preValue = preRow ? preRow["informationPeriodStartTime"] + "-" + preRow["informationPeriodEndTime"] : null;
        // 如果当前值和上一行的值相同，则将当前单元格隐藏
        if (currentValue === preValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          // 否则计算当前单元格应该跨越多少行
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.billList.hunPrice.length; i++) {
            const nextRow = this.billList.hunPrice[i];
            const nextValue = nextRow["informationPeriodStartTime"] + "-" + nextRow["informationPeriodEndTime"];
            if (nextValue === currentValue) {
              rowspan++;
            } else {
              break;
            }
          }
          return { rowspan, colspan: 1 };
        }
      }
    },
    pumpPriceObjectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0 && this.statementsType !== 4) {
        // 获取当前单元格的值
        const currentValue = row["pumpCarName"];
        // 获取上一行相同列的值
        const preRow = this.billList.pumpPrice[rowIndex - 1];
        const preValue = preRow ? preRow["pumpCarName"] : null;
        // 如果当前值和上一行的值相同，则将当前单元格隐藏
        if (currentValue === preValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          // 否则计算当前单元格应该跨越多少行
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.billList.pumpPrice.length; i++) {
            const nextRow = this.billList.pumpPrice[i];
            const nextValue = nextRow["pumpCarName"];
            if (nextValue === currentValue) {
              rowspan++;
            } else {
              break;
            }
          }
          return { rowspan, colspan: 1 };
        }
      }
    },
    deleteBill(id) {
      this.$confirm("此操作将永久删除该结算单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteFinalStatement({ id: id }).then(res => {
            if (res.code == 1001) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.gettableData();
            }
          });
        })
        .catch(() => {});
    },
    download() {
      this.$Download(this.statementsType == 1 || this.statementsType == 2 ? exportRawSettlement : exportSettlement, { id: this.low.id });
    },
    //添加配比
    addItem() {
      this.billList.splitPrice.push({
        rawName: "",
        rawId: "",
        splitNum: "",
        type: 5,
      });
    },
    deleteItem(index) {
      this.billList.splitPrice.splice(index, 1);
    },
    /*配比原物料选择 */
    /**单选列表打开 */
    ListChoiceTypeFun(index, id) {
      this.ListChoiceType = true;
      this.ListChoiceDataIndex = index;
      if (id) {
        this.ListChoiceRadio = id;
        this.ListChoiceRadioCopy = id;
      } else {
        this.ListChoiceRadio = "";
        this.ListChoiceRadioCopy = "";
      }
      this.checkName = "";
      this.checkTypeId = "";
      this.ListChoicePagingFun();
    },
    //单选选中
    ListChoiceFun(currentRow) {
      if (currentRow) {
        console.log(this.ListChoiceRadio + ";" + currentRow.id);
        let type = this.billList.splitPrice.findIndex(res => res.rawId == currentRow.id);
        if (type == -1 || this.ListChoiceRadioCopy == currentRow.id) {
          this.ListChoiceRadio = currentRow.id;
          this.ListChoiceRadioRow = currentRow;
        } else {
          this.$message({
            message: "该选项已被选择！",
            type: "warning",
          });
          setTimeout(() => {
            this.ListChoiceRadioRow = "";
          }, 100);
        }
      }
    },
    /**保存和校验不重复选中项 */
    ListChoiceAddFun() {
      //原物料选择后对应值【品牌，规格..】带入表格中
      this.billList.splitPrice[this.ListChoiceDataIndex].rawId = this.ListChoiceRadioRow.rawId;
      this.billList.splitPrice[this.ListChoiceDataIndex].rawName = this.ListChoiceRadioRow.name + "_" + this.ListChoiceRadioRow.specification + "_" + this.ListChoiceRadioRow.brand + "_" + this.ListChoiceRadioRow.originPlace;
      this.ListChoiceType = false;
    },
    /**分页查询列表 */
    ListChoicePagingFun(type) {
      if (!type) {
        this.ListChoicePaging.page = 1;
        this.ListChoicePaging.name = this.checkName;
        this.ListChoicePaging.typeId = this.checkTypeId;
      }
      console.log(this.ListChoicePaging);
      rawMaterialsQueryPage(this.ListChoicePaging).then(res => {
        this.ListChoiceData = res.data.data;
        this.ListChoicePaging.total = res.data.totalRows;
      });
    },
    /**生成结算单*/
    statements1(row, index) {
      this.statementsNoIndex = index;
      this.statementsNoRow = row;

      if (row.settlementStatus == 2) {
        selectRawSettleDetail({ secondSettleId: row.id }).then(res => {
          if (res.code == 1001) {
            this.billListChildren = res.data;
            this.billDetailsChildren.supperName = res.data.mainSupperPrice[0].supperName;
            this.billDetailsChildren.supperId = res.data.mainSupperPrice[0].supperId;
            this.billDetailsChildren.createTime = this.low.settlementPeriod.substring(0, 19);
            this.billDetailsChildren.updateTime = this.low.settlementPeriod.substring(20, 39);
            this.billListChildren.rawSettleData = res.data.splitPrice[0];
            this.deductionListChildren = res.data.adjustPrice || [];
            this.totalListChildren = res.data.mainSupperPrice;
          }
          this.billDetaChildren = true;
        });
      } else {
        createRawSettle(row).then(res => {
          this.deductionListChildren = [];
          res.data.rawSettleData.id = "";
          this.billListChildren = res.data;
          this.billDetailsChildren.supperName = res.data.rawSettleData.supperName;
          this.billDetailsChildren.supperId = res.data.rawSettleData.supperId;
          if (this.low.settlementPeriod) {
            this.billDetailsChildren.createTime = this.low.settlementPeriod.substring(0, 19);
            this.billDetailsChildren.updateTime = this.low.settlementPeriod.substring(20, 39);
          } else {
            this.billDetailsChildren.createTime = this.generate.createTime;
            this.billDetailsChildren.updateTime = this.generate.updateTime;
          }
          this.billDetaChildren = true;
        });
      }
    },
    /**调整金额*/
    delItem1(index) {
      this.deductionList.splice(index, 1);
    },
    addItem1() {
      let obj = {
        stationId: "",
        station: "",
        adjustModule: "",
        deductionType: "",
        adjustMoney: "",
        isInvoice: 0,
        remark: "",
        type: "",
      };
      this.deductionList.push(obj);
    },
    /**子结算单调整金额*/
    delItem1Children(index) {
      this.deductionList.splice(index, 1);
    },
    addItem1Children() {
      let obj = {
        station:"",
        stationId:"",
        adjustModule: "",
        deductionType: "",
        adjustMoney: "",
        isInvoice: 0,
        remark: "",
        type: "",
      };
      this.deductionListChildren.push(obj);
    },
    init() {
      this.tableData = [];
      this.datePicker = [];
      this.tableParam = this.$options.data().tableParam;
      this.tableParam.contractType = 6;
      this.searchText = "";
      this.searchradio = "";
      if (this.currenindex == 1) {
        this.table = this.table1;
        this.queryPage = queryPage1;
        this.tableParam.isSettle = 0;
        this.tableParam.pageSize = 10;
      }
      if (this.currenindex == 2) {
        this.tableParam.type = 1;
        this.table = this.table2;
        this.getsearchData();
        this.queryPage = queryPage2;
      }
      if (this.currenindex == 3) {
        this.table = this.table3;
        this.tableParam.type = 1;
        this.queryPage = queryPage3;
        this.getsearchData();
      }
      this.gettableData();
    },
    /**结算信息合计*/
    combined(arr) {
      let num = 0;
      if (arr.length > 0) {
        arr.forEach(res => {
          num = Number(res.settlementMoney) + num;
        });
      }
      return num.toFixed(2);
    },
    /**结算信息合计*/
    combinedsettleMoney(arr) {
      let num = 0;
      if (arr.length > 0) {
        arr.forEach(res => {
          num = Number(res.settleMoney || 0) + num;
        });
      }
      return num.toFixed(2);
    },
    /**结算信息合计*/
    combined1(index) {
      let num = 0;
      this.billList[index].forEach(res => {
        num = Number(res.settlementMoney) + num;
      });
      return num.toFixed(2);
    },
    /*结算金额合计type:1结算金额2开票金额 */
    combined2(type) {
      let num = 0;
      let row = this.totalList[0];
      let productMoney = this.statementsType == 3 ? Number(row.productMoney) : 0;
      if (type == 1) {
        num = productMoney + Number(row.transportMoney) + Number(row.pumpMoney) + Number(row.specialTransportMoney) + Number(row.machineMoney) + Number(row.adjustMoney);
      } else if (type == 2) {
        num = productMoney + Number(row.transportMoney) + Number(row.pumpMoney) + Number(row.specialTransportMoney) + Number(row.machineMoney) + Number(row.isAdjustMoney);
      }
      return num.toFixed(2);
    },
    /*子结算金额合计type:1结算金额2开票金额 */
    combined2Children(type) {
      let num = 0;
      let row = this.totalListChildren[0];
      if (type == 1) {
        num = Number(row.rawMoney) + Number(row.adjustMoney);
      } else if (type == 2) {
        num = Number(row.rawMoney) + Number(row.isAdjustMoney);
      }
      return num.toFixed(2);
    },
    /*调整金额合计type:1全部,2影响开票金额合计,3不影响开票金额合计 */
    combined3(type) {
      let num = 0;
      this.deductionList.forEach(res => {
        if (type == 1) {
          num = res.type ? num + Number(res.adjustMoney) : num - Number(res.adjustMoney);
        } else if (type == 2) {
          if (res.isInvoice == 1) {
            num = res.type ? num + Number(res.adjustMoney) : num - Number(res.adjustMoney);
          }
        } else if (type == 3) {
          if (res.isInvoice == 0) {
            num = res.type ? num + Number(res.adjustMoney) : num - Number(res.adjustMoney);
          }
        }
      });
      return num.toFixed(2);
    },
    /*子调整金额合计type:1全部,2影响开票金额合计,3不影响开票金额合计 */
    combined3Children(type) {
      let num = 0;
      this.deductionListChildren.forEach(res => {
        if (type == 1) {
          num = res.type ? num + Number(res.adjustMoney) : num - Number(res.adjustMoney);
        } else if (type == 2) {
          if (res.isInvoice == 1) {
            num = res.type ? num + Number(res.adjustMoney) : num - Number(res.adjustMoney);
          }
        } else if (type == 3) {
          if (res.isInvoice == 0) {
            num = res.type ? num + Number(res.adjustMoney) : num - Number(res.adjustMoney);
          }
        }
      });
      return num.toFixed(2);
    },
    /**结算合计*/
    settotalList: _debounce(function () {
      console.log("111222333");
      console.log(this.totalList);
      console.log(this.low.settlementStatus);
      this.totalList[0]["settlementStatus"] = this.low ? this.low.settlementStatus : "";
      this.totalList[0].supperName = this.totalList[0].supperName ? this.totalList[0].supperName : this.billDetails.outsourcingUnit;
      this.totalList[0].contractSigningSubjectId = this.totalList[0].contractSigningSubjectId ? this.totalList[0].contractSigningSubjectId : this.billDetails.contractSigningSubjectId;
      this.totalList[0].contractSigningSubject = this.totalList[0].contractSigningSubject ? this.totalList[0].contractSigningSubject : this.billDetails.contractSigningSubject;
      this.totalList[0].betonMoney = this.combined1("hunPrice") * 1;
      this.totalList[0].productMoney = this.combined1("hunPrice") * 1;
      this.totalList[0].highOverMoney = this.combined1("highOverPrice") * 1;
      this.totalList[0].transportMoney =
        Number(this.combined1("yunPrice")) +
        Number(this.billList.assistTransportPrice.settlementMoney || 0) +
        (this.billList.supplyCarPrice ? Number(this.billList.supplyCarPrice.settlementMoney || 0) : Number(this.combined1("supplyNumPrice")));
      this.totalList[0].pumpMoney = Number(this.combined1("pumpPrice")) + Number(this.billList.assistPumpPrice.settlementMoney || 0);
      this.totalList[0].machineMoney = this.combined1("jiaPrice") * 1;
      this.totalList[0].specialTransportMoney = this.combined1("specialTran") * 1;
      this.totalList[0].adjustMoney = this.combined3(1);
      this.totalList[0].isAdjustMoney = this.combined3(2);
      this.totalList[0].noAdjustMoney = this.combined3(3);
      this.totalList[0].settleMoney = this.combined2(1);
      this.totalList[0].invoiceMoney = this.combined2(2);
      this.allTotalList = [...this.totalList, ...this.billList.splitPrice];
    }),
    /**子结算合计*/
    settotalListChildren: _debounce(function () {
      this.totalListChildren[0].supperName = this.billListChildren.rawSettleData.supperName;
      this.totalListChildren[0].adjustMoney = this.combined3Children(1) * 1;
      this.totalListChildren[0].isAdjustMoney = this.combined3Children(2) * 1;
      this.totalListChildren[0].noAdjustMoney = this.combined3Children(3) * 1;
      this.totalListChildren[0].rawMoney = this.statementsType == 1 ? this.billListChildren.rawSettleData.splitMoney : this.billListChildren.rawSettleData.settlementMoney;
      this.totalListChildren[0].settleMoney = this.combined2Children(1) * 1;
      this.totalListChildren[0].invoiceMoney = this.combined2Children(2) * 1;
    }),
    /**导航栏切换*/
    choose(pages) {
      this.pagesLoading = true;
      this.currenindex = pages;
    },
    /**获取对应的搜搜添加*/
    getsearchData() {
      contract_list({ contractTypeId: 6, supplierName: this.supplierNameSearch }).then(res => {
        console.log(res.data);
        this.searchData = res.data;
      });
      // if (_this.currenindex == 2) {
      //   getSupplierListForsettlement().then(res => {
      //     console.log(res.data);
      //     if (res.data) {
      //       this.SupplierList = res.data;
      //     }
      //   });
      // }
      // if (_this.currenindex == 3) {
      //   getSupplierListForsettlement().then(res => {
      //     console.log(res.data);
      //     if (res.data) {
      //       this.SupplierList = res.data;
      //     }
      //   });
      // }
    },
    /**合同列表选中*/
    setradio(data) {
      this.searchradio = JSON.stringify(data);
    },
    /**确定选择运输合同*/
    submitsearch() {
      let row = JSON.parse(this.searchradio);
      this.tableParam.contractId = row.contractId;
      this.searchText = row.contractNumber + "-" + row.supplierName;
      this.search = false;
      if (this.tableParam.startTime) {
        this.gettableData();
      }
    },
    /**查询 */
    pagesgettableData() {
      this.gettableData();
    },
    /**表格选中数据*/
    tableChange(val) {
      this.generate.list = val;
      this.generate.createTime = this.tableParam.startTime;
      this.generate.updateTime = this.tableParam.endTime;
    },
    /**生成结算单*/
    statements() {
      if (!this.tableParam.contractId) {
        this.$message.warning("请先选择协外单位再生成结算单！");
        return;
      }
      createFinalStatement(this.generate.list).then(res => {
        //判断合同类型 statementsType:1理论配合比,2实际配合比,3购销,4配合比抵扣
        if (res.code == 1001) {
          if (res.data.contractType == 1) {
            this.statementsType = 3;
          }
          if (res.data.contractType == 2 && res.data.contractMethod == 1) {
            this.statementsType = 1;
          }
          if (res.data.contractType == 2 && res.data.contractMethod == 2) {
            this.statementsType = 2;
          }
          if (res.data.contractType == 2 && res.data.contractMethod == 3) {
            this.statementsType = 4;
          }
          this.billList = res.data;
          this.billList.hunPrice.forEach(item => {
            item.settlementPrice = item.price;
          });
          let outsourcingData = JSON.parse(this.searchradio);
          this.deductionList = [];
          this.compenList = [];
          this.selectCompenList = [];
          this.billDetails.outsourcingUnit = outsourcingData.supplierName;
          this.billDetails["outsourcingUnitId"] = outsourcingData.supplierId;
          this.billDetails["contractSigningSubjectId"] = outsourcingData.contractSigningSubjectId;
          this.billDetails["contractSigningSubject"] = outsourcingData.contractSigningSubject;
          this.billDetails.createTime = this.generate.createTime;
          this.billDetails.updateTime = this.generate.updateTime;
          this.billDeta = true;
          this.lookSendersStatus = false;
          console.log(res.data);
        }
      });
    },
    /*提交子结算单 */
    combinedSubmitChildren() {
      let _this = this;
      //先保存主结算单
      let newbillDetails = {
        createTime: _this.billDetails.createTime || _this.billDetails1.createTime,
        updateTime: _this.billDetails.updateTime || _this.billDetails1.updateTime,
        outsourcingUnit: _this.billDetails.outsourcingUnit || _this.billDetails1.outsourcingUnit,
        outsourcingUnitId: _this.billDetails.outsourcingUnitId || _this.billDetails1.outsourcingUnitId,
      };
      let data = {
        ..._this.billList,
        settlementPeriod: newbillDetails.createTime + "-" + newbillDetails.updateTime,
        balanceList: _this.selectCompenList,
        compenList: _this.compenList,
        type: 2,
        auditStatus: 1,
        imgUrl: "",
        totalPrice: _this.totalList,
        hunAdjustPrice: _this.deductionList,
        supperName: newbillDetails.outsourcingUnit,
        supperId: newbillDetails.outsourcingUnitId,
        contractId: _this.tableParam.contractId || _this.low.contractId,
        mainBalanceNo: "",
        money: this.totalList[0].settleMoney,
        settlementStatus: _this.low.settlementStatus || "",
        id: _this.billList.settlementInfo ? _this.billList.settlementInfo.id : "",
      };
      this.saveStatus = true;
      saveFinalStatement(data).then(res => {
        if (res.code == 1001) {
          let secondSettleId = "";
          if (_this.statementsNoRow.id) {
            secondSettleId = _this.statementsNoRow.id;
          } else {
            let arr = res.data.splitPrice.find(item => item.contractRawId == _this.statementsNoRow.contractRawId);
            secondSettleId = arr.id;
          }

          let dataRaw = {
            ..._this.billListChildren,
            settlementPeriod: _this.billDetailsChildren.createTime + "-" + _this.billDetailsChildren.updateTime,
            type: 2,
            auditStatus: 1,
            imgUrl: "",
            totalPrice: _this.totalListChildren,
            splitJustPrice: _this.deductionListChildren,
            supperName: _this.billDetailsChildren.supperName,
            supperId: _this.billDetailsChildren.supperId,
            contractId: _this.tableParam.contractId,
            mainBalanceNo: res.data.balanceId,
            secondSettleId: secondSettleId,
            splitPrice: [_this.billListChildren.rawSettleData],
            settlementStatus: 2,
            id: _this.billListChildren.statements ? _this.billListChildren.statements.id : "",
          };
          _this.low = res.data.OuterStatements;
          saveRawStatement(dataRaw).then(res2 => {
            if (res2.code == 1001) {
              _this.billDeta = false;
              _this.show(_this.low);
              this.tableParam.page = 1;
              this.pagesgettableData();
              _this.billDetaChildren = false;
            }
            _this.saveStatus = false;
          });
        }
      });
    },
    /**提交结算单*/
    combinedSubmit(type) {
      let _this = this;
      if (type == 3) {
        _this.$router.push({ name: "sign_Wise_contactsbusiness2", query: { id: this.low.id, type: 1 } });
        return;
      }
      if (this.statementsType !== 4) {
        let type = false;
        this.billList.hunPrice.forEach(item => {
          if (!item.settlementPrice && item.settlementPrice != 0) {
            type = true;
          }
        });
        if (type) {
          this.$message.warning("产品费用结算单价为空，请到结算价维护!");
          return;
        }
      }
      let settlementStatus = false;
      let splitMoney = 0;
      if (this.statementsType !== 3 && this.statementsType !== 4) {
        _this.billList.splitPrice?.forEach(item => {
          splitMoney = splitMoney + item.splitMoney * 1;
          if (item.settlementStatus != 2) {
            settlementStatus = true;
          }
        });
      }
      if (!settlementStatus && this.statementsType == 1) {
        if (splitMoney * 1 != this.combined(this.billList.hunPrice) * 1) {
          this.$message.warning("产品费用拆分金额不等于结算金额，不允许结算!");
          return;
        }
      }
      this.saveStatus = true;
      new Promise(resolve => {
        html2canvas(_this.$refs.html).then(canvas => {
          canvas.toBlob(blob => {
            const file = new File([blob], "结算截图.jpg", { type: "image/jpg" });
            const params = new FormData();
            params.append("file", file);
            uploadFile(params).then(res => {
              if (res.code === 1001) {
                resolve(res.data.fileUrl);
              }
            });
          });
        });
      }).then(value => {
        let newbillDetails = {
          createTime: this.billDetails.createTime || this.billDetails1.createTime,
          updateTime: this.billDetails.updateTime || this.billDetails1.updateTime,
          outsourcingUnit: this.billDetails.outsourcingUnit || this.billDetails1.outsourcingUnit,
          outsourcingUnitId: this.billDetails.outsourcingUnitId || this.billDetails1.outsourcingUnitId,
        };
        let data = {
          ..._this.billList,
          balanceList: _this.selectCompenList,
          compenList: _this.compenList,
          settlementPeriod: newbillDetails.createTime + "-" + newbillDetails.updateTime,
          type: 2,
          auditStatus: 1,
          imgUrl: value,
          totalPrice: this.totalList,
          hunAdjustPrice: this.deductionList,
          supperName: newbillDetails.outsourcingUnit,
          supperId: newbillDetails.outsourcingUnitId,
          contractId: this.tableParam.contractId,
          settlementStatus: settlementStatus ? 1 : 2,
          money: this.totalList[0].settleMoney,
          mainBalanceNo: "",
          id: this.billList.settlementInfo ? this.billList.settlementInfo.id : "",
        };
        saveFinalStatement(data).then(res => {
          if (res.code == 1001) {
            _this.billDeta = false;
            _this.billDeta1 = false;
            if (type == 2) {
              _this.$router.push({ name: "sign_Wise_contactsbusiness2", query: { id: res.data.id, type: 1 } });
              return;
            }
            _this.gettableData();
          }
          _this.saveStatus = false;
        });
      });
    },
    show(low) {
      let _this = this;
      this.low = low;
      selectSettleDetail({ id: low.id }).then(res => {
        if (res.code == 1001) {
          if (res.data.settlementInfo.contractType == 1) {
            this.statementsType = 3;
          }
          if (res.data.settlementInfo.contractType == 2 && res.data.settlementInfo.contractMethod == 1) {
            this.statementsType = 1;
          }
          if (res.data.settlementInfo.contractType == 2 && res.data.settlementInfo.contractMethod == 2) {
            this.statementsType = 2;
          }
          if (res.data.settlementInfo.contractType == 2 && res.data.settlementInfo.contractMethod == 3) {
            this.statementsType = 4;
          }
          _this.billList = res.data;
          //给拆分数据增加结算状态
          _this.billList.splitPrice?.forEach((item, index) => {
            item.settlementStatus = item.isSettle ? "2" : "1";
            item.invoiceMoney = res.data.rawTotalPrice.length > 0 ? res.data.rawTotalPrice[index].invoiceMoney : 0;
            item.settleMoney = res.data.rawTotalPrice.length > 0 ? res.data.rawTotalPrice[index].settleMoney : 0;
          });
          _this.billDetails = [];
          _this.billDetails1.supplierName = res.data.settlementInfo.supplierName;
          _this.billDetails1.supplierId = res.data.settlementInfo.supplierId;
          _this.billDetails1.outsourcingUnit = res.data.settlementInfo.supplierName;
          _this.billDetails1.outsourcingUnitId = res.data.settlementInfo.supplierId;
          _this.billDetails1.settlementPeriod = res.data.settlementInfo.settlementPeriod;
          _this.billDetails1.balanceNo = res.data.settlementInfo.balanceNo;
          _this.billDetails1.createTime = this.low.settlementPeriod.substring(0, 19);
          _this.billDetails1.updateTime = this.low.settlementPeriod.substring(20, 39);
          _this.deductionList = JSON.parse(JSON.stringify(res.data.adjustPrice));
          _this.compenList = JSON.parse(JSON.stringify(res.data.compenList));
          this.getSpanArr(_this.compenList);
          _this.totalList = JSON.parse(JSON.stringify(res.data.mainSupperPrice));
          getCompensationListHistory({ balanceNo: low.id }).then(res2 => {
            if (res.code == 1001) {
              _this.selectCompenList = res2.data;
              _this.billDeta1 = true;
              _this.lookSendersStatus = true;
            }
          });
        }
      });
    },
    /**结算单发给供应商*/
    // send(low) {
    //   this.low = low
    //   this.userarr = []
    //   this.useroptons = []
    //   queryUserByID({ id: low.contractId }).then(res => {
    //     this.useroptons = JSON.parse(res.data)
    //     this.userDeta = true
    //   })
    //   // send_to_customer(low).then(() => {
    //   //   this.gettableData()
    //   // })
    // },
    async userSubmit(low) {
      this.$confirm("确认发送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(async () => {
        let json = {
          contractId: low.contractId,
          type: 1,
          settlementId: low.id,
          settlementNo: low.code,
          times: low.settlementPeriod,
          money: low.money,
          applyForTime: low.createTime,
          imgUrl: low.imgUrl,
        };
        // let arr = this.userarr.map(res => (new useritem(res)))
        informClient(json).then(res => {
          if (res.code == 1001) {
            updateSettledPage({ id: low.id, outerStatus: 1 }).then(() => {});
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.gettableData();
            this.userDeta = false;
          }
        });
      });
    },
    outsourceexportListFun() {
      let json = { id: this.low.id };
      this.$Download(outsourceexportList, json);
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.pagesgettableData();
    },
    changeSizes() {
      this.tableParam.pageSize = this.curElPage;
      if (this.currenindex !== 3) {
        this.pagesgettableData();
      } else {
        this.gettableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  padding: 20px 20px 0 20px;
  max-height: 400px;
  overflow: auto;
}
.tabtop {
  width: 571px;
}
.el-input,
.el-select {
  width: 240px;
}
/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
.bill_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    font-weight: 600;
    color: #000;
  }
}
.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}
.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}
.bill_subtitle {
  padding: 20px 0;
  > span {
    padding-right: 20px;
  }
  .text {
    color: #000;
  }
}
.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}
</style>
